import { render, staticRenderFns } from "./DragDropDashboard.vue?vue&type=template&id=40215be8&scoped=true&"
import script from "./DragDropDashboard.vue?vue&type=script&lang=js&"
export * from "./DragDropDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DragDropDashboard.vue?vue&type=style&index=0&id=40215be8&prod&scoped=true&lang=css&"
import style1 from "./DragDropDashboard.vue?vue&type=style&index=1&id=40215be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40215be8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDialog,VProgressCircular,VRow})
